import { PART_ATTRIBUTE } from "./constants";
import type { NoticePart } from "./types";

/**
 * A stable hook the admin's custom CSS targets, as `[data-redacto-part="…"]`.
 * Spread into an element's attributes: `el("div", { ...part("footer") })`.
 */
export const part = (name: NoticePart): Record<string, string> => ({
  [PART_ATTRIBUTE]: name,
});
